import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { ChargePerson, ChargeShipping } from 'types/Charge';
import { maskDocument } from 'utils/formatters';
import { Field } from 'components/DetailSection';

const ShippingViewer: React.FC<{
  shipping: ChargeShipping;
}> = ({ shipping }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const linhas: [string, string | undefined][] = [
    ['Endereço', shipping.street],
    ['Número', shipping.number],
    ['Complemento', shipping.complement],
    ['Bairro', shipping.district],
    ['Cidade', shipping.city],
    ['Estado', shipping.state],
  ];

  return (
    <>
      <Button size="sm" colorScheme="brand" variant="outline" onClick={onOpen}>
        Exibir endereço
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Dados de entrega</ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="auto">
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              {linhas.map(([label, value]) => (
                <Field key={label} title={label}>
                  {value || '---'}
                </Field>
              ))}
            </SimpleGrid>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="brand" onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

/**
 * Um pagador é um registro só, e uma tabela de uma linha é a forma mais cara possível de
 * mostrar cinco campos. Vira grid de campos — o que também elimina a célula de endereço, que
 * era renderizada solta dentro do `<Tr>`, sem `<Td>` em volta.
 */
const Devedor: React.FC<{
  person?: ChargePerson;
  shipping?: ChargeShipping;
}> = ({ person, shipping }) => {
  if (!person) return null;

  return (
    <SimpleGrid columns={{ base: 1, md: 3, xl: 5 }} spacing={4}>
      <Field title="Nome">{person.name || '---'}</Field>
      <Field title="Documento">{person.document ? maskDocument(person.document) : '---'}</Field>
      <Field title="E-mail">{person.email || '---'}</Field>
      <Field title="IP do usuário">{person.ip ?? '---'}</Field>
      <Field title="Endereço">{shipping ? <ShippingViewer shipping={shipping} /> : 'Não informado'}</Field>
    </SimpleGrid>
  );
};

export default Devedor;
